const permissionMainfestsXml =
    `<?xml version="1.0" encoding="utf-8"?>
<manifest xmlns:android="http://schemas.android.com/apk/res/android"
    package="com.example">
    <uses-permission android:name="android.permission.READ_CONTACTS" />
    <application
        android:allowBackup="true"
        android:icon="@mipmap/ic_launcher"
        android:label="@string/app_name"
        android:roundIcon="@mipmap/ic_launcher_round"
        android:supportsRtl="true"
        android:theme="@style/Theme.AllExample">
        <activity
            android:name=".MainActivity"
            android:exported="true">
            <intent-filter>
                <action android:name="android.intent.action.MAIN" />

                <category android:name="android.intent.category.LAUNCHER" />
            </intent-filter>
        </activity>
    </application>

</manifest>`
const singlePermissionXMl =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout 
    xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <Button
        android:id="@+id/permissionBtn"
        android:layout_width="wrap_content"
        android:layout_height="wrap_content"
        android:text="@string/permission"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintLeft_toLeftOf="parent"
        app:layout_constraintRight_toRightOf="parent"
        app:layout_constraintTop_toTopOf="parent" />

</androidx.constraintlayout.widget.ConstraintLayout>`

const permissionMethod =
    `package com.example

import android.app.Activity
import android.content.DialogInterface
import android.content.Intent
import android.content.pm.PackageManager
import android.net.Uri
import android.provider.Settings
import android.widget.Toast
import androidx.core.app.ActivityCompat
import androidx.core.content.ContextCompat
import com.google.android.material.dialog.MaterialAlertDialogBuilder

object Permission {
    fun checkSinglePermission(
        activity: Activity,
        permission: String,
        permissionCode: Int
    ): Boolean {
        if (ContextCompat.checkSelfPermission(
                activity,
                permission
            ) == PackageManager.PERMISSION_DENIED
        ) {
            ActivityCompat.requestPermissions(
                activity,
                arrayOf(permission),
                permissionCode
            )
        } else {
            return true
        }
        return false
    }

    fun settingActivityOpen(activity: Activity) {
        Toast.makeText(
            activity,
            "Go to settings and enable permissions",
            Toast.LENGTH_LONG
        )
            .show()
        val i = Intent()
        i.action = Settings.ACTION_APPLICATION_DETAILS_SETTINGS
        i.addCategory(Intent.CATEGORY_DEFAULT)
        val packageName= activity.packageName
        i.data = Uri.parse("package:$packageName")
        i.addFlags(Intent.FLAG_ACTIVITY_NEW_TASK)
        i.addFlags(Intent.FLAG_ACTIVITY_NO_HISTORY)
        i.addFlags(Intent.FLAG_ACTIVITY_EXCLUDE_FROM_RECENTS)
        activity.startActivity(i)
    }

    fun showDialogOK(activity: Activity,okListener: DialogInterface.OnClickListener) {
        MaterialAlertDialogBuilder(activity)
            .setMessage("Permission is required for this app")
            .setPositiveButton("OK", okListener)
            .setNegativeButton("Cancel", okListener)
            .create()
            .show()
    }
}`
const singlePermissionKt =
    `package com.example
import android.Manifest
import android.content.DialogInterface
import android.content.pm.PackageManager
import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.widget.Button
import android.widget.Toast
import androidx.core.app.ActivityCompat
import com.example.Permission.checkPermissionAny
import com.example.Permission.settingActivityOpen
import com.example.Permission.showDialogOK

class MainActivity : AppCompatActivity() {
    private val permissionRequestId = 1
    private val permissionRequestN = Manifest.permission.READ_CONTACTS
    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        findViewById<Button>(R.id.permissionBtn).setOnClickListener {
            if (checkPermissionAny(
                    this,
                    permissionRequestN,
                    permissionRequestId
                )
            ) {
                doOperation()
            }
        }
    }

    override fun onRequestPermissionsResult(
        requestCode: Int,
        permissions: Array<out String>,
        grantResults: IntArray
    ) {
        super.onRequestPermissionsResult(requestCode, permissions, grantResults)
        if (requestCode == permissionRequestId) {
            if (grantResults.isNotEmpty() && grantResults[0] == PackageManager.PERMISSION_GRANTED) {
                doOperation()
            } else {
                if (!ActivityCompat.shouldShowRequestPermissionRationale(
                        this,
                        permissionRequestN
                    )
                ) {
                    if (ActivityCompat.checkSelfPermission(
                            this,
                            permissionRequestN
                        ) == PackageManager.PERMISSION_DENIED
                    ) {
                        settingActivityOpen(this)
                    }
                } else {
                    showDialogOK(this) { _: DialogInterface?, which: Int ->
                        when (which) {
                            DialogInterface.BUTTON_POSITIVE -> {
                                if (checkPermissionAny(
                                        this,
                                        permissionRequestN,
                                        permissionRequestId
                                    )
                                ) {
                                    doOperation()
                                }
                            }
                            DialogInterface.BUTTON_NEGATIVE -> {
                            }
                        }
                    }

                }
            }
        }
    }

    private fun doOperation() {
        Toast.makeText(this,"Successfully",Toast.LENGTH_LONG).show()
    }
}`
const permissionStr =
    `<resources>
    <string name="app_name">Run-time Permission</string>
    <string name="permission">Permission</string>
</resources>`
module.exports = { permissionMainfestsXml: permissionMainfestsXml, singlePermissionXMl: singlePermissionXMl, permissionStr: permissionStr, permissionMethod: permissionMethod, singlePermissionKt: singlePermissionKt };